import Modal from "react-modal";
import React, { useContext, useEffect } from "react";
import firstLogo from "../../images/Group18.png";
import secondLogo from "../../images/VectorSmartObject.png";
import { ScoreContext } from "../../Context/ScoreContext";
import coin from "../../images/coin.svg";
import "../WinModal/WinModal.css";
import { Link, useNavigate } from "react-router-dom";
import { LevelContext } from "../../Context/LevelContext";
import UserNameContext from "../../Context/UserNameContext.js";
import axios from "axios";
import Footer from "../Footer/Footer";
import { useState } from "react";
// import backgroundVideo from "../../videos/golden-particles.mov";

export const WinModal = ({ show, onClose, restartGame, currentLevel }) => {
  const { score, totalScore, setScore } = useContext(ScoreContext);
  const { userName, setUserName } = useContext(UserNameContext);
  const { completeLevel } = useContext(LevelContext);
  const navigate = useNavigate();
  const [showRef, setShow] = useState(false);

  // Function to handle opening and closing the modal
  const handleShowReferences = () => {
    setShow(true);
  };
  const handleClose = () => setShow(false);

  useEffect(() => {
    const storedName = localStorage.getItem("userName");
    if (storedName) setUserName(storedName);
  }, []);

  const postVisitorScore = () => {
    axios
      .post("https://findzok.com/api/visitors", {
        id: localStorage.getItem("userId"),
        name: localStorage.getItem("userName"),
        score: score,
      })
      .then((response) => {
        localStorage.setItem("userId", response.data.data.id);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleReturn = () => {
    postVisitorScore();
    localStorage.setItem("score", 0);
    setScore(0);
  };

  const handleNextLevel = () => {
    completeLevel(currentLevel + 1);
    localStorage.setItem("score", totalScore);
    navigate(`/theme-${currentLevel + 1}`); // Adjust the route according to your setup
    postVisitorScore();
    onClose();
  };

  return (
    <>
      <Modal className="winModalBox" isOpen={show} onRequestClose={onClose}>
        <div className="container-fluid">
          <div className="flex-grow flex flex-col lg:justify-center items-center">
            <div className="winModalCotainer pt-4">
              <div className="winContent h-screen w-screen overflow-auto flex flex-col lg:justify-center items-center">
                <div className="flex-grow flex justify-center items-center flex-col">
                  <h1 className="mb-3">Congratulations! </h1>

                  <h3 className="placed">
                    Thank You Dr. {userName} for your time.
                  </h3>
                  <h5 className="placed">You placed all circles correctly.</h5>
                  <h3>Your score is {score}/200</h3>

                  <div className="d-flex justify-content-center align-items-center mt-4 flex-wrap ">
                    <button onClick={restartGame} className=" playButton">
                      Play Again
                    </button>
                    {currentLevel === 2 && (
                      <div>
                        <Link to="/choose-theme">
                          <button
                            onClick={handleReturn}
                            className="playButton "
                          >
                            Return Home{" "}
                          </button>
                        </Link>
                      </div>
                    )}
                    {currentLevel < 2 && (
                      <div>
                        <Link to="/choose-theme">
                          <button className="playButton">Return Home </button>
                        </Link>
                        <button
                          onClick={handleNextLevel}
                          className="nextButton"
                        >
                          To Next Level
                        </button>
                      </div>
                    )}
                    <button
                      onClick={handleShowReferences}
                      className=" playButton"
                    >
                      References
                    </button>
                  </div>
                </div>

                <Footer />
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        style={{ zIndex: 1001 }}
        className="referencesModal"
        isOpen={showRef}
        onRequestClose={onClose}
      >
        <div className="flex-grow flex flex-col justify-center items-center  ">
          <div className=" h-screen w-screen overflow-auto flex flex-col justify-center items-center modalRef">
            <div className="modalContentRef">
              <h2 className="">References: </h2>
              <ul>
                <li>1- European Heart Journal (2021) 42, 3227–3337</li>
                <li>
                  2- Journal of the American Society of Hypertension 12 (8),
                  579.e1–579.e73
                </li>
                <li>3- Full prescribing information of Betaloc ZOK</li>
                <li>4- European Heart Journal (2018) 39, 3021–3104</li>
                <li>5- European Heart Journal (2020) 42, 3734–98</li>
              </ul>
              <div className="d-flex justify-content-center align-items-center mt-2 flex-wrap ">
                <button onClick={handleClose} className="closeButton">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

{
  /* <div className="d-flex mt-md-4 mt-0  justify-content-center  ">
             

             <div className=" bg-white w-25 rounded-md">
               <img src={QRCode} alt="" />
             </div>
           
           </div> */
}
{
  /* <div className="row justify-content-center mt-md-4 mt-0 ">
                  <div className="col-6 col-md-4">
                    <img className="img-fluid" src={QRCode} alt="" />
                  </div>
                </div> */
}

{
  /* <div className="contentScore">
                  <div className="mr-5">
                    <img className="w-100 " src={firstLogo} alt="" />
                  </div>
                  {currentLevel === 3 && (
                    <div className="totalScore mr-5 ">
                      <h4>Total Score </h4>{" "}
                    
                      <div className="scoreBox">
                        <span className="scoreNum">{score}</span>
                        <img className="coinImage3" src={coin} alt="" />
                      </div>
                    </div>
                  )}
                  <div>
                    <img className="w-100 mb-2" src={secondLogo} alt="" />
                  </div>
                </div> */
}
